import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';

import initialState from './initial';
import { clearedDefaults, failedDefaults, requestedDefaults, succeededDefaults } from './utils';

export const createAccount = (state: any = initialState.accounts.create, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.CREATE_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.CREATE_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.CREATE_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.create;
    default:
      return state;
  }
};

export const patchAccount = (state: any = initialState.accounts.patch, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.PATCH_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.PATCH_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.PATCH_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.PATCH_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.patch;
    default:
      return state;
  }
};

export const patchJointAccountInterest = (state: any = initialState.accounts.patchJointInterest, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.PATCH_JOINT_ACCOUNT_INTEREST):
      return clearedDefaults(state);
    case State.actionRequested(Type.PATCH_JOINT_ACCOUNT_INTEREST):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.PATCH_JOINT_ACCOUNT_INTEREST):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.PATCH_JOINT_ACCOUNT_INTEREST):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.patchJointInterest;
    default:
      return state;
  }
};

export const patchBeneficiaries = (state: any = initialState.accounts.patchBeneficiaries, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.PATCH_ACCOUNT_BENEFICIARIES):
      return clearedDefaults(state);
    case State.actionRequested(Type.PATCH_ACCOUNT_BENEFICIARIES):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.PATCH_ACCOUNT_BENEFICIARIES):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.PATCH_ACCOUNT_BENEFICIARIES):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.patchBeneficiaries;
    default:
      return state;
  }
};

export const updateSuitabilityInformation = (
  state: any = initialState.accounts.updateSuitabilityInformation,
  action: any,
) => {
  switch (action.type) {
    case State.actionCleared(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION):
      return clearedDefaults(state);
    case State.actionRequested(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.updateSuitabilityInformation;
    default:
      return state;
  }
};

// Financial assets
export const updateFinancialAssets = (state: any = initialState.accounts.updateFinancialAssets, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS):
      return clearedDefaults(state);
    case State.actionRequested(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.updateFinancialAssets;
    default:
      return state;
  }
};

export const getAccount = (state: any = initialState.accounts.item, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.item;
    default:
      return state;
  }
};

export const refresh = (state: any = initialState.accounts.refresh, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.REFRESH_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.REFRESH_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.REFRESH_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.REFRESH_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.refresh;
    default:
      return state;
  }
};

export const submit = (state: any = initialState.accounts.submit, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.SUBMIT_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.SUBMIT_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.SUBMIT_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.SUBMIT_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.submit;
    default:
      return state;
  }
};

export const link = (state: any = initialState.accounts.link, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.LINK_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.LINK_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.LINK_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.LINK_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.link;
    default:
      return state;
  }
};

export const updateSignature = (state: any = initialState.accounts.updateSignature, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.UPDATE_ACCOUNT_SIGNATURE):
      return clearedDefaults(state);
    case State.actionRequested(Type.UPDATE_ACCOUNT_SIGNATURE):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.UPDATE_ACCOUNT_SIGNATURE):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.UPDATE_ACCOUNT_SIGNATURE):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.updateSignature;
    default:
      return state;
  }
};

export const switchAccount = (state: any = initialState.accounts.switch, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.SWITCH_ACCOUNT):
      return clearedDefaults(state);
    case State.actionRequested(Type.SWITCH_ACCOUNT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.SWITCH_ACCOUNT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accounts.submit;
    default:
      return state;
  }
};

export const accountsReducers = combineReducers({
  item: getAccount,
  refresh,
  submit,
  link,
  create: createAccount,
  patch: patchAccount,
  patchJointInterest: patchJointAccountInterest,
  patchBeneficiaries,
  updateSuitabilityInformation,
  updateFinancialAssets,
  updateSignature,
  switch: switchAccount,
});
